export const VOLTAGE = {
  min: 2000,
  max: 4400,
};

export const AMPERAGE = {
  min: 0,
  max: 2000,
};

export const ADMIN_ACTIONS = {
  ACTIVE: "ACTIVE",
  TECHNICAL_CHECKUP: "TECHNICAL_CHECKUP",
  BROKEN: "BROKEN",
  LOST: "LOST"
};



// WEBPACK FOOTER //
// ./src/views/pages/chargers/constants.js